import React from "react"
import {connect} from "react-redux";
import BrowseView from "../../browse/BrowseView";
import {Row, Col, Button} from "antd"
import {NavLink} from "react-router-dom"
import {bindActionCreators} from "redux"
import * as LovTypeActions from "../../reducers/lov";
import PropTypes from "prop-types";
import LovResultTable from "./LovResultTable";


class LovResultTypes extends React.Component {
    static propTypes = {
        lov: PropTypes.array.isRequired,
        lovTypesFetch: PropTypes.bool.isRequired,
        search: PropTypes.func.isRequired
    };
    state = {
        selectedRowKeys: []
    };
    render() {
        const {getLovTypeResults, lov, lovTypesFetch, search} = this.props;
        const {selectedRowKeys} = this.state;
        const selectedId = selectedRowKeys[0];
        const disabled = selectedRowKeys.length === 0;
        const titleBar = <Row>
            <Col span={4}>LOV Result</Col>
            <Col span={1} offset={19}>
                <NavLink to={`/result/${selectedId}`}>
                    <Button type='primary' disabled={disabled}>Open</Button>
                </NavLink>
            </Col>
        </Row>
        return <BrowseView
            masterTitle={titleBar}
            master={<LovResultTable dataSource={lov} onSelectChange={this.onSelectChange}
                                           loading={lovTypesFetch} compact={false}/>}
            initialQuery={getLovTypeResults}
            searchableProps={["type"]}
            vertical={false}
            searchLogic={search}
            loading={lovTypesFetch}
        />

    }
}

const mapStateToProps = state => ({
    lov: state.lov.lovTypes,
    lovTypesFetch: state.lov.lovTypesFetch
});

const mapDispatchToProps = dispatch => ({
    getLovTypeResults: bindActionCreators(LovTypeActions, dispatch).getLovTypeResults,
    search: bindActionCreators(LovTypeActions, dispatch).search
});

export default connect(mapStateToProps, mapDispatchToProps)(LovResultTypes)


// WEBPACK FOOTER //
// ./src/js/lovs/result/lovResultTypes.js